window.customValidation = () => {
  const getProductVariantValue = (selector) => document.querySelector(selector)?.value;
  const checkUpsellCondition = (value) => window.specificUpsellData?.some(item => item.id == value) && window.candyVariantIds?.length > 1 && window.specificUpsellData?.length > 0;

  let err = null;
  const lowerCaseVariantTitle = window.currentVariant?.title?.toLowerCase();
  const validationData = [
    { selector: ".candle-product-variant-id", message: 'Oops! Only 1 candy can be added with a candle. Please update your order to continue.' },
    { selector: ".perfume-product-variant-id", message: 'Oops! You have too many add-ons in your order, please remove one item to continue.' },
    { selector: ".hand-cream-product-variant-id", message: 'Oops! You have too many add-ons in your order, please remove one item to continue.' },
    { selector: ".signature-tote-product-variant-id", message: 'Oops! You have too many add-ons in your order, please remove one item to continue.' }
  ];

  for (let item of validationData) {
    let productVariantValue = getProductVariantValue(item.selector);
    if (productVariantValue && checkUpsellCondition(productVariantValue)) {
      return item.message;
    }
  }

  if (!lowerCaseVariantTitle?.includes("mini") && !lowerCaseVariantTitle?.includes("no vase")) {
    let customCandyAddBtn = document.querySelector('.custom__candy--add-btn');
    if (customCandyAddBtn && window.candyVariantIds?.length > 1) {
      customCandyAddBtn.disabled = false;
      err = 'Oops! Only 1 candy can be added with a vase. Please update your order to continue.';
    }
  }
  return err;
};

window.addEventListener('load', window.customValidation);
